import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
  size?: 'normal' | 'large';
}

export default function VideoCard({ video, size = 'normal' }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-200 ${
        size === 'large' ? 'aspect-[16/9] sm:aspect-[2/1]' : 'aspect-[3/4]'
      }`}>
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 白云视频高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

        {video.isVip && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
            VIP
          </span>
        )}
        {video.isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
            新
          </span>
        )}
        {video.isHot && !video.isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
            热播
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <p className="text-xs text-background-50/80 mb-1">
            {video.duration} · {video.rating}分
          </p>
          <h3 className="text-sm font-medium text-background-50 line-clamp-2 leading-snug">
            {video.title}
          </h3>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>

      {size === 'large' && (
        <div className="mt-3">
          <div className="flex items-center gap-2 flex-wrap">
            {video.tags.slice(0, 3).map((tag) => (
              <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded whitespace-nowrap">
                {tag}
              </span>
            ))}
          </div>
          <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
            {video.description}
          </p>
        </div>
      )}
    </Link>
  );
}